import React from "react";

const CancelBrokenIcon = () => {
  return (
    <>
     <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.664 10a8.333 8.333 0 108.333-8.333"
        stroke="#344054"
        strokeWidth={1.2}
        strokeLinejoin="round"
      />
      <path
        d="M9.997 1.667A8.333 8.333 0 001.664 10"
        stroke="#344054"
        strokeWidth={1.2}
        strokeLinejoin="round"
        strokeDasharray="3 2"
      />
      <path
        d="M13.33 6.667L9.998 10m0 0l-3.333 3.334M9.997 10l3.334 3.334M9.997 10L6.664 6.667"
        stroke="#344054"
        strokeWidth={1.2}
        strokeLinejoin="round"
      />
    </svg>
    </>
  );
};

export default CancelBrokenIcon;
